/** Explicit staff param for "Alle medarbejdere" (every active member). */
export const APPOINTMENTS_STAFF_ALL_EMPLOYEES = 'employees';

export function isAppointmentsAllEmployees(staffParam: string | null | undefined): boolean {
  return staffParam === APPOINTMENTS_STAFF_ALL_EMPLOYEES;
}

/**
 * Resolves the /appointments time-view clinician filter.
 *
 * An explicit `staff` query param always wins. When it is absent, the logged-in
 * user is selected if they appear in the clinic staff list; otherwise the
 * existing All-staff default is kept.
 *
 * `memberIds` is null while clinic members are still loading so the logged-in
 * user can be used optimistically and then confirmed (or cleared) once the
 * list arrives.
 */
export function resolveAppointmentsStaffFilter(input: {
  staffParam: string | null;
  hasExplicitStaffParam: boolean;
  currentUserId: string | null | undefined;
  memberIds: readonly string[] | null;
}): string | null {
  const { staffParam, hasExplicitStaffParam, currentUserId, memberIds } = input;

  if (hasExplicitStaffParam) {
    if (!staffParam || staffParam === 'all' || isAppointmentsAllEmployees(staffParam)) return null;
    if (staffParam.includes(',')) return null;
    if (memberIds == null) return staffParam;
    if (memberIds.includes(staffParam)) return staffParam;
    return defaultStaffFilter(currentUserId, memberIds);
  }

  if (memberIds == null) {
    return currentUserId ?? null;
  }

  return defaultStaffFilter(currentUserId, memberIds);
}

function defaultStaffFilter(
  currentUserId: string | null | undefined,
  memberIds: readonly string[],
): string | null {
  if (currentUserId && memberIds.includes(currentUserId)) {
    return currentUserId;
  }
  return null;
}

export function staffSearchValueFromSelection(clinicianId: string | null): string {
  return clinicianId ?? 'all';
}
